export const acceptedAttachments = [
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'text/plain',
  'application/pdf',
  'application/vnd.oasis.opendocument.text',
  'application/vnd.oasis.opendocument.spreadsheet',
  'application/vnd.oasis.opendocument.presentation',
  'application/vnd.apple.pages',
  'application/vnd.apple.numbers',
  'application/vnd.apple.keynote',
  'application/vnd.ms-outlook',
  'message/rfc822',
  'image/jpeg',
  'image/jpeg',
  'image/gif',
  'image/bmp',
  'image/dib',
  'image/png',
  'video/mp4'
];



// WEBPACK FOOTER //
// ./src/shared/consts/acceptedAttachments.ts